import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BlogApprovalQueue } from '../components/blog/BlogApprovalQueue';
import { useBlogStore } from '../store/blogStore';
import { useAuthStore } from '../store/authStore';
import { PermissionGuard } from '../components/auth/PermissionGuard';

export const EditorDashboardPage = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { posts, updatePost } = useBlogStore();

  if (!user) {
    navigate('/editor/login');
    return null;
  }

  const handleApprove = async (postId: string) => {
    updatePost(postId, {
      status: 'published',
      publishedAt: new Date(),
    });
  };

  const handleReject = async (postId: string) => {
    updatePost(postId, {
      status: 'rejected',
    });
  };

  return (
    <PermissionGuard
      permissions={['manage_platform_settings']}
      fallback={<div>Access denied</div>}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Editorial Dashboard</h1>
            <p className="mt-2 text-gray-600">
              Review and manage submitted blog posts
            </p>
          </div>
          <button
            onClick={() => useAuthStore.getState().clearAuth()}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700"
          >
            Sign Out
          </button>
        </div>

        <div className="space-y-6">
          <BlogApprovalQueue
            posts={posts}
            onApprove={handleApprove}
            onReject={handleReject}
          />
        </div>
      </div>
    </PermissionGuard>
  );
};